
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, forwardRef, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from "@angular/core";
import { TaskOptionComponent } from "../task-option.component";
import { Project } from "../../../../models";
import { Store } from "@ngrx/store";
import { TasksRootState, getProjectsList } from "../../../../store/index";
import { takeWhile } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { TaskService } from "src/app/task/task.service";
import { TaskRepository } from "src/app/task/repository/task.repository";

@Component({
  selector: "vp-new-vnctask-option-link-project",
  providers: [{
    provide: TaskOptionComponent,
    // eslint-disable-next-line
    useExisting: forwardRef(() => NewTaskLinkProjectOptionComponent)
  }],
  templateUrl: "new-option-link-project.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewTaskLinkProjectOptionComponent extends TaskOptionComponent implements OnInit, OnDestroy {
  id: string = "link-to-project";
  triggerKey = "=";
  isAlive = true;

  constructor(private store: Store<TasksRootState>,
    public changerDetectorRef: ChangeDetectorRef,
    private service: TaskService,
    private taskRepo: TaskRepository,
    public matDialog: MatDialog ) {
    super(changerDetectorRef, matDialog);
    this.service.cancelActivationOfTags.subscribe(res => {
      this.cancelActivateData();
    });
  }

  ngOnInit() {
    this.store.select(getProjectsList).pipe(takeWhile(() => this.isAlive)).subscribe( projects => {
      this.setItems(projects);
    });
  }

  getPayload() {
    let value: Project = this.getValue();
    if (!value) return { };
    return { project_id: value.id, project_name: value.name };
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  activate:boolean = false;

  @Output() selectActivate = new EventEmitter();
  @Output() selectedProject = new EventEmitter();

  selectActivateData() {
    this.activate = true;
    this.selectActivate.emit(this.activate);
    this.changerDetectorRef.markForCheck();
  }

  cancelActivateData() {
    this.activate = false;
    this.selectActivate.emit(this.activate);
  }

  selectedData(item){
    console.log("selectedData ", item);
    console.log("TaskAddUserOptionComponent members user", item);
    this.taskRepo.getMemberList(item.id);

    this.selectedProject.emit(item);
    this.activate = false;
    this.selectActivate.emit(this.activate);
    this.changerDetectorRef.markForCheck();
  }

}
